import { FormatAlignJustify } from "@mui/icons-material";
import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  main: {
    display: "flex",
    justifyContent: "end",
    marginBottom: "10px",
    marginTop: "10px",
  },
}));
